import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import { usePermissions } from "../../common/PermissionContext";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const ExternalCompAttempts = () => {

    const [sportsList, setSportsList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [attemptsList, setAttemptsList] = useState<any[]>([]);
    const [athltAttemptList, setAthltAttemptList] = useState<any[]>([]);
    const [competitionList, setCompetitionList] = useState<any[]>([]);
    const [sinclairList, setSinclairList] = useState<any[]>([]);
    const [attemptValues, setAttemptValues] = useState<any>({});
    const [sportId, setSportId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [compId, setCompId] = useState("");
    const [cycleId, setCycleId] = useState("");
    const [genderId, setGenderId] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const genderList = [{ extComGenderId: 1, extComGenderName: "Men" }, { extComGenderId: 2, extComGenderName: "Women" }];


    useEffect(() => {
        fetchAttempts();
    }, []);

    async function fetchAttempts() {
        setIsLoading(true);
        const attemptResponse = await func.externalCompAthleteAttempts(null);
        setAthltAttemptList(Array.isArray(attemptResponse) ? attemptResponse : [])
        setIsLoading(false);
    }

    const filteredData = athltAttemptList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const competitionRender = (rowData) => {
        return <span>{rowData.competitionName}</span>;
    };

    const liftTypeRender = (rowData) => {
        return <span>{rowData.liftName}</span>;
    };

    const weightLiftedRender = (rowData) => {
        return <span>{rowData.extComWeightLifted}</span>;
    };

    const attemptRender = (rowData) => {
        return <span>{rowData.extComAttemptNum}</span>;
    };

    const handleAttemptChange = (
        formatId: string,
        attemptIndex: number,
        value: string,
    ) => {
        setAttemptValues((prev: any) => {
            const updated = prev[formatId]
                ? [...prev[formatId]]
                : [];

            while (updated.length <= attemptIndex) {
                updated.push({
                    attempt: updated.length + 1,
                    value: "",
                    success: false
                });
            }

            updated[attemptIndex] = {
                ...updated[attemptIndex],
                value
            };

            return {
                ...prev,
                [formatId]: updated
            };
        });
    };

    const handleSuccessChange = (
        formatId: string,
        attemptIndex: number,
        checked: boolean
    ) => {
        setAttemptValues((prev: any) => {

            const updated = prev[formatId]
                ? [...prev[formatId]]
                : [];

            while (updated.length <= attemptIndex) {
                updated.push({
                    attempt: updated.length + 1,
                    value: "",
                    success: false
                });
            }

            updated[attemptIndex] = {
                ...updated[attemptIndex],
                success: checked
            };

            return {
                ...prev,
                [formatId]: updated
            };
        });
    };

    async function newSprtRsltFrmtAtmpt() {
        setOpenModal(true)
        setAttemptValues({});
        const sportResponse = await func.externalSports(null);
        setSportsList(Array.isArray(sportResponse) ? sportResponse : [])
        const athltResponse = await func.externalCompAthletes(null);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : []);
        const eventResponse = await func.externalCompEvents(null);
        setCompetitionList(Array.isArray(eventResponse) ? eventResponse : []);
        const sinclairConstantsResponse = await func.externalCompSinclairConts(null);
        setSinclairList(Array.isArray(sinclairConstantsResponse) ? sinclairConstantsResponse : [])
    }

    async function handleRows(sportId: string | null) {
        const attemptsResponse = await func.externalCompAttempts(sportId);
        setAttemptsList(Array.isArray(attemptsResponse) ? attemptsResponse : [])
    }

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateExternalResultFormat();
            } else {
                const formData = new FormData();
                formData.append("extComSportId", sportId);
                formData.append("attempts", JSON.stringify(attemptValues));
                formData.append("extComAthleteId", athleteId);
                formData.append("extComCompetitionId", compId);
                formData.append("cycal", cycleId);
                formData.append("gender", genderId);

                // formData.forEach((value, key) => {
                //     console.log(`${key}: ${value}`);
                // });
                const createAttempts = api.ExternalCompetitionAttempts;
                fetch(createAttempts, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchAttempts();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })

            }
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Result Formats Attempts</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newSprtRsltFrmtAtmpt() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Sport Result Format Attempts">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                body={athleteRender}
                                                header="Athlete"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionName"
                                                body={competitionRender}
                                                header="Competition"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="liftName"
                                                body={liftTypeRender}
                                                header="Lift Type"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComAttemptNum"
                                                body={attemptRender}
                                                header="Attempt"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComWeightLifted"
                                                body={weightLiftedRender}
                                                header="Weight Lifted"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                size="xl"
                centered
                show={openModal}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Result Format</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Athlete</label>
                                    <Select
                                        value={athleteList.find(athlt => athlt.extComAthleteId === athleteId) ? {
                                            value: athleteId,
                                            label: athleteList.find(athlt => athlt.extComAthleteId === athleteId).extComAthleteName
                                        } : null}
                                        onChange={(e) => {
                                            setAthleteId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={athleteList.map(athlt => ({
                                            value: athlt.extComAthleteId,
                                            label: athlt.extComAthleteName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competition </label>
                                    <Select
                                        value={competitionList.find(cmp => cmp.extComEventId === compId) ? {
                                            value: compId,
                                            label: competitionList.find(cmp => cmp.extComEventId === compId).extComEventName
                                        } : null}
                                        onChange={(e) => {
                                            setCompId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={competitionList.map(cmp => ({
                                            value: cmp.extComEventId,
                                            label: cmp.extComEventName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Sport</label>
                                    <Select
                                        value={sportsList.find(sprt => sprt.extComSportId === sportId) ? {
                                            value: sportId,
                                            label: sportsList.find(sprt => sprt.extComSportId === sportId).extComSportName
                                        } : null}
                                        onChange={async (e) => {
                                            setSportId(e.value);
                                            handleRows(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={sportsList.map(sprt => ({
                                            value: sprt.extComSportId,
                                            label: sprt.extComSportName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Cycle</label>
                                    <Select
                                        value={sinclairList.find(snclr => snclr.extComOlympicCycle === cycleId) ? {
                                            value: cycleId,
                                            label: sinclairList.find(snclr => snclr.extComOlympicCycle === cycleId).extComOlympicCycle + "-" +
                                                sinclairList.find(snclr => snclr.extComOlympicCycle === cycleId).extComGender
                                        } : null}
                                        onChange={(e: any) => {
                                            if (e) {
                                                setCycleId(e.value);
                                            }
                                        }}
                                        styles={customSelect}
                                        required
                                        options={sinclairList.map(snclr => ({
                                            value: snclr.extComOlympicCycle,
                                            label: snclr.extComOlympicCycle + "-" + snclr.extComGender
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Gender</label>
                                    <Select
                                        value={genderList.find(gender => gender.extComGenderName === genderId) ? {
                                            value: genderId,
                                            label: genderList.find(gender => gender.extComGenderName === genderId)?.extComGenderName ?? genderId
                                        } : null}
                                        onChange={(e: any) => {
                                            if (e) {
                                                setGenderId(e.value);
                                            }
                                        }}
                                        styles={customSelect}
                                        required
                                        options={genderList.map(gender => ({
                                            value: gender.extComGenderName,
                                            label: gender.extComGenderName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {attemptsList.map((format) => (
                                <div className="col-12 mb-4" key={format.extComSportFormatId}>
                                    <h5>{format.extComSportFormat}</h5>

                                    <div className="row">
                                        {Array.from(
                                            { length: Number(format.attempts) },
                                            (_, index) => (
                                                <div
                                                    className="col-md-4 mb-3"
                                                    key={`${format.extComSportFormatId}-${index}`}
                                                >
                                                    <label className="form-label">
                                                        Attempt {index + 1}
                                                    </label>

                                                    <div className="d-flex align-items-center gap-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={
                                                                attemptValues[
                                                                    format.extComSportFormatId
                                                                ]?.[index]?.value || ""
                                                            }
                                                            onChange={(e) =>
                                                                handleAttemptChange(
                                                                    format.extComSportFormatId,
                                                                    index,
                                                                    e.target.value
                                                                )
                                                            }
                                                        />

                                                        <label className="form-label">
                                                            Success?
                                                        </label>
                                                        <div className="form-check m-0">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={
                                                                    attemptValues[
                                                                        format.extComSportFormatId
                                                                    ]?.[index]?.success || false
                                                                }
                                                                onChange={(e) =>
                                                                    handleSuccessChange(
                                                                        format.extComSportFormatId,
                                                                        index,
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ExternalCompAttempts;